var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 53,
    viewBox: "0 0 129 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.8626 26.237C53.8626 22.1792 57.152 18.8897 61.2098 18.8897H74.2363C78.294 18.8897 81.5835 22.1792 81.5835 26.237C81.5835 30.2948 78.294 33.5843 74.2362 33.5843H61.2098C57.152 33.5843 53.8626 30.2948 53.8626 26.237Z",
    stroke: "white",
    strokeWidth: 2.14106
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2655 29.8494C60.2655 27.7859 61.9383 26.1131 64.0018 26.1131H71.4403C73.5038 26.1131 75.1766 27.7859 75.1766 29.8494C75.1766 31.9129 73.5038 33.5857 71.4403 33.5857H64.0018C61.9383 33.5857 60.2655 31.9129 60.2655 29.8494Z",
    stroke: "white",
    strokeWidth: 2.14106
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9995 12.9694H52.7651",
    stroke: "white",
    strokeWidth: 2.14106,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2159 21.481L55.4641 20.9708",
    stroke: "white",
    strokeWidth: 2.14106,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3826 15.6083L43.3826 11.3939",
    stroke: "white",
    strokeWidth: 2.14106,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3835 25.9989C41.8189 25.9989 40.5505 24.7305 40.5505 23.1658L40.5505 19.7103C40.5505 18.1456 41.8189 16.8772 43.3835 16.8772C44.9482 16.8772 46.2166 18.1456 46.2166 19.7103V23.1658C46.2166 24.7305 44.9482 25.9989 43.3835 25.9989Z",
    stroke: "white",
    strokeWidth: 2.14106
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M101.443 12.9694H82.6773",
    stroke: "white",
    strokeWidth: 2.14106,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2788 21.481L79.9809 20.9708",
    stroke: "white",
    strokeWidth: 2.14106,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0623 15.6083L92.0626 11.3939",
    stroke: "white",
    strokeWidth: 2.14106,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8937 23.1658C94.8937 24.7305 93.6253 25.9989 92.0607 25.9989C90.496 25.9989 89.2276 24.7305 89.2276 23.1658L89.2276 19.7103C89.2276 18.1456 90.496 16.8772 92.0607 16.8772C93.6253 16.8772 94.8937 18.1456 94.8937 19.7103V23.1658Z",
    stroke: "white",
    strokeWidth: 2.14106
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0468 33.8544L77.4483 37.5429",
    stroke: "white",
    strokeWidth: 2.14106,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M60.398 33.8544L57.9965 37.5429",
    stroke: "white",
    strokeWidth: 2.14106,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4035 18.8956H64.053L64.053 16.7202C64.053 14.7585 65.6793 13.1339 67.7283 13.1339C69.7772 13.1339 71.4035 14.7585 71.4035 16.7202V18.8956Z",
    stroke: "white",
    strokeWidth: 2.14106
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrone);
export default __webpack_public_path__ + "static/media/drone.aba12bab17f0f2f6c4efeab28f31ae3e.svg";
export { ForwardRef as ReactComponent };